/**
 * Brand identifiers shared by runtime config and build tooling.
 *
 * Kept separate from `config.ts` so tools like GraphQL codegen can import
 * brand constants without requiring `NEXT_PUBLIC_BRAND` to be set.
 */

export type Brand = 'gallet' | 'breitling' | 'ug';

export const BRAND_ENUM = {
  Gallet: 'gallet',
  Breitling: 'breitling',
  Ug: 'ug',
} as const satisfies Record<string, Brand>;

export const SUPPORTED_BRANDS: readonly Brand[] = Object.values(BRAND_ENUM);
